import React from 'react';
import { Box, Typography } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

interface OverweightOrderBannerProps {
    overweightInfo: {
        color: string;
        eircode: string;
        linkedOverweightOrderIds: string[];
    }
}

const OverweightOrderBanner = (props: OverweightOrderBannerProps) => {

    const getLinkedOrders = () => {
        const shortOrderIds = props.overweightInfo.linkedOverweightOrderIds;
        return shortOrderIds.join(', ');
    };

    return (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
            }}
        >
        <Box
            pl={0.5}
            display={'flex'}
            alignItems="center"
            justifyContent={'space-between'}
            sx={{
                padding: '8px 8px 8px 12px',
                borderTopLeftRadius: 4,
                borderTopRightRadius: 4,
                bgcolor: props?.overweightInfo?.color || '#ED050514',
                flex: 1
            }}
        >
            <Typography
                noWrap
                variant={'body1'}
                sx={{
                    color: 'white',
                    fontWeight: 600,
                    fontSize: 12,
                }}
            >
                Linked Orders: {getLinkedOrders()}
            </Typography>
        </Box>
        </Box>
    );
};

export default OverweightOrderBanner;